import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 21",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M.761 13.827a10 10 0 1 1 18.477-7.654A10 10 0 0 1 .76 13.827ZM15.057 7.54a.75.75 0 1 0-1.2-.9l-4.842 6.457a.5.5 0 0 1-.753.053l-2.5-2.5a.75.75 0 1 0-1.06 1.06l2.5 2.5a2 2 0 0 0 3.013-.213l4.842-6.457Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }